import React from 'react'
import { IonButton, IonModal } from '@ionic/react'
import { _dict } from '../constants';
import ReactPlayer from 'react-player';
import { useUIStore } from '../stateManagement/UIZustand';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface YoutubeModalProps {
    
}
function YoutubeModal(props: YoutubeModalProps) {
  const {videoURL, setVideoURL} = useUIStore();
  const {lang} = useGlobalStore();
  return (
    <IonModal isOpen={videoURL !== undefined } onDidDismiss={() => setVideoURL(undefined)}>
      <div style={{margin:"auto"}}>
        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
          <IonButton onClick={() => setVideoURL(undefined)} color="danger" size="large">
            {_dict.dismiss[lang]}
          </IonButton>
        </div>
        
      </div>
      <ReactPlayer url={videoURL} controls width="100%" height='100%' />
  </IonModal>
  )
}

export default YoutubeModal